/* @indexer:no-export */
import * as React from 'react';
import './TableCaption.css';
import I18n from '../../I18n/I18n/I18n';
export default function TableCaption(_ref) {
  var caption = _ref.caption,
    captionId = _ref.captionId;
  return /*#__PURE__*/React.createElement("span", {
    id: captionId,
    className: "dm-table__caption"
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: caption
  }));
}